const normalizeLineBreaks = (copy) => copy?.replace(/\\n/g, '\n');

export default normalizeLineBreaks;
